import { ProcessState } from "./models";
import { makeAutoObservable, reaction, observable, runInAction } from "mobx";
import { createCellStateKey } from "../Utils";
export class DataStoreImpl {
    constructor(rootStore, serviceClient) {
        this.tableModel = { columns: [] };
        this.data = [];
        this.dataStock = [];
        this.dataStockRequested = false;
        this.dataStockFilled = false;
        this.dataState = ProcessState.NONE;
        this.cellStates = observable.map();
        this.currentLoadingProcessId = null;
        this.showRowsWithFailure = true;
        makeAutoObservable(this);
        this.serviceClient = serviceClient;
        this.rootStore = rootStore;
        reaction(() => this.rootStore.jobPanelStore.selectedEntry, () => {
            if (this.rootStore.jobPanelStore.selectedEntry) {
                this.loadData();
                this.loadTableModel();
            }
        });
    }
    loadData() {
        runInAction(() => {
            this.dataState = ProcessState.LOADING;
        });
        let loadingProcess = Math.floor(Math.random() * 100000);
        this.currentLoadingProcessId = loadingProcess;
        let filter = this.rootStore.filterStore.getCurrentFilterAsString();
        this.loadDataInternal(0, loadingProcess, this.showRowsWithFailure, filter);
    }
    loadDataInternal(nextLink, loadingProcessId, showRowsWithFailures, filter) {
        const handleSuccess = (response) => {
            if (loadingProcessId != this.currentLoadingProcessId || !this.rootStore.jobPanelStore.selectedEntry) {
                return;
            }
            let result = response.body;
            if (nextLink == 0) {
                runInAction(() => {
                    this.data = result.value;
                    this.dataStock = result.value;
                    this.dataState = ProcessState.SUCCESS;
                });
            }
            else {
                runInAction(() => {
                    this.dataStock.push(...result.value);
                    this.dataStockFilled = true;
                });
                if (this.dataStockRequested) {
                    runInAction(() => {
                        this.dataStockRequested = false;
                    });
                    this.requestDataStock();
                }
            }
            if (result.nextLink) {
                this.loadDataInternal(result.nextLink, loadingProcessId, showRowsWithFailures, filter);
            }
            else {
                runInAction(() => {
                    this.currentLoadingProcessId = null;
                });
            }
        };
        const handleError = (error) => {
            console.log(error);
            this.rootStore.notificationStore.handleError(error);
            runInAction(() => {
                this.data = [];
                this.dataState = ProcessState.ERROR;
            });
        };
        let entryId = this.rootStore.jobPanelStore.selectedEntry.id;
        let panelId = this.rootStore.jobPanelStore.selectedEntry.panelId;
        let requestParams = { panelId: panelId, entryId: entryId, nextLink: nextLink };
        if (filter) {
            requestParams["filter"] = filter;
        }
        if (showRowsWithFailures) {
            requestParams["onlyValidationFailures"] = showRowsWithFailures;
        }
        this.serviceClient
            .then((client) => client.apis.job_panel.getData(requestParams, {}))
            .then((response) => {
            handleSuccess(response);
        })
            .catch((error) => {
            handleError(error);
        });
    }
    requestDataStock() {
        if (this.dataStockFilled) {
            runInAction(() => {
                this.data = this.dataStock.slice();
                this.dataStockFilled = false;
            });
        }
        else {
            runInAction(() => {
                this.dataStockRequested = true;
            });
        }
    }
    loadTableModel() {
        let entryId = this.rootStore.jobPanelStore.selectedEntry.id;
        let panelId = this.rootStore.jobPanelStore.selectedEntry.panelId;
        this.serviceClient
            .then((client) => client.apis.job_panel.getTableModel({ panelId: panelId, entryId: entryId }, {}))
            .then((response) => {
            runInAction(() => {
                this.tableModel = response.body;
            });
        });
    }
    loadCellState(col, code) {
        let entryId = this.rootStore.jobPanelStore.selectedEntry.id;
        let panelId = this.rootStore.jobPanelStore.selectedEntry.panelId;
        this.serviceClient.then((client) => client.apis.dataintegration.get_cell_state({ panelId: panelId, entryId: entryId, column: col, code: code }).then((response) => {
            this.cellStates.set(createCellStateKey(col, code), response.body);
        }));
    }
    updataData(row, col, value) {
        let positions = this.tableModel.columns
            .filter((col) => col.isPrimaryKey)
            .map((col) => {
            return { columnLabel: col.label, rowValue: row[col.label] };
        });
        let body = {
            positions: positions,
            columnLabel: col,
            value: value,
        };
        let entryId = this.rootStore.jobPanelStore.selectedEntry.id;
        let panelId = this.rootStore.jobPanelStore.selectedEntry.panelId;
        this.serviceClient.then((client) => client.apis.job_panel
            .updateCell({ panelId: panelId, entryId: entryId }, { requestBody: body })
            .then((response) => {
            this.loadData();
            this.rootStore.jobPanelStore.loadJobPanels();
        })
            .catch((error) => {
            this.rootStore.notificationStore.handleError(error);
            this.loadData();
        }));
    }
    setShowRowsWithFailure(show) {
        runInAction(() => {
            this.showRowsWithFailure = show;
            this.loadData();
        });
    }
}
